export const projects = [
    {
      id: 1,
      img: "https://res.cloudinary.com/thisisnotanimage/image/upload/v1649440598/Phaedonv_industries_portal/screencapture-alavastronpartyposters-2022-04-08-19_30_39_edited_lhbxew.png",
      link: "https://alavastronparty.netlify.app/",
    },
    {
      id: 2,
      img: "https://res.cloudinary.com/thisisnotanimage/image/upload/v1683785153/Recipio%20App/recipio_scroller_ycdevq.png",
      link: "https://recipio.netlify.app/",
    },
    {
      id: 3,
      img: "https://res.cloudinary.com/thisisnotanimage/image/upload/v1612352318/TunesOfFreedom_oqf7n2.png",
      link: "https://tunesoffreedom.herokuapp.com/",
    },
    /*{
      id: 4,
      img: "https://res.cloudinary.com/thisisnotanimage/image/upload/v1612352318/TunesOfFreedom_oqf7n2.png",
      link: "https://tunesoffreedom.herokuapp.com/",
    },
    {
      id: 5,
      img: "https://res.cloudinary.com/thisisnotanimage/image/upload/v1612352318/TunesOfFreedom_oqf7n2.png",
      link: "https://tunesoffreedom.herokuapp.com/",
    },
    {
      id: 6,
      img: "https://res.cloudinary.com/thisisnotanimage/image/upload/v1612352318/TunesOfFreedom_oqf7n2.png",
      link: "https://tunesoffreedom.herokuapp.com/",
    },*/
  ];